module.exports = __webpack_public_path__ + "static/media/Rub.svg";